export const standardQuestionsPathName = 'ai';
export const standardQuestionsListPathName = 'standard-questions';
export const dialogPromptsPathName = 'dialog-support';
export const dialogSupportInstructionsPathName = 'instructions';
export const dialogSupportInstructionCreatePathName = 'new';
export const municipalDocumentsPathName = 'municipal-documents';
export const glossaryPathName = 'glossary';

export const assessmentPromptsPathName = 'support-assessments';
